import actionCable from 'actioncable';

const buildCableUrl = () => {
  if (process.env.NODE_ENV === 'development') {
    return 'ws://localhost:5000/cable';
  }
  const onStaging = window.location.hostname === 'staging.medsender.com';
  const appUrl = onStaging ? 'staging.medsender.com' : 'app.medsender.com';
  return `wss://${appUrl}/cable`;
};

const cable = actionCable.createConsumer(buildCableUrl());
export default cable;
